var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c("div", { staticClass: "container" }, [
            _c("form", { staticClass: "quotetool__step" }, [
              _c("h2", { staticClass: "quotetool__step-heading" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.labels.stepFourTitle) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "quotetool__step-form-container" },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.bankVerification == false
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v("Your bank information is not valid"),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.period) + " Year Source for Business Plan"
                      ),
                    ]),
                    _vm._v(
                      " ending " +
                        _vm._s(_vm.endingDate) +
                        " for " +
                        _vm._s(_vm.waterSitesCount) +
                        " site(s) with total combined consumption of " +
                        _vm._s(_vm.annualUsage) +
                        " m"
                    ),
                    _c("sup", [_vm._v("3")]),
                    _vm._v(" p/year\n                "),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm._f("toCurrency")(_vm.totalCharge, 2))),
                    ]),
                    _vm._v(" estimated annual charge"),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.paymentType.$error },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.labels.stepFourPaymentTypeLabel)),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.paymentType.$model,
                                expression: "$v.paymentType.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "paymentType",
                              id: "paymentTypeDD",
                              value: "DD",
                            },
                            domProps: {
                              checked: _vm._q(_vm.$v.paymentType.$model, "DD"),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.paymentType,
                                  "$model",
                                  "DD"
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepFourPaymentTypeDDLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.paymentType.$model,
                                expression: "$v.paymentType.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "paymentType",
                              id: "paymentTypeBACS",
                              value: "BACS",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.$v.paymentType.$model,
                                "BACS"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.paymentType,
                                  "$model",
                                  "BACS"
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepFourPaymentTypeBACSLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.paymentType.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepFourPaymentTypeValidationMsg)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bacsVisible
                    ? _c("div", [
                        _c("p", [_vm._v("Payment information for BACS")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                        Payments: " +
                              _vm._s(
                                _vm._f("toCurrency")(_vm.totalCharge / 2, 2)
                              ) +
                              " bi-annually\n                        Recipient: Pennon Water Services Ltd t/a Source for Business"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        Bank: 10 Gresham Street, London, EC2V 7AE"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        Acc. Number: 00220418"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        Sort: 30-00-00\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                        Note that by confirming your purchase you are also confirming intent to send payment to the above details by BACS.\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ddVisible
                    ? _c("div", [
                        _c("h4", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.labels.stepFourDirectDebitHeading) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "form-group--error": _vm.$v.paymentDate.$error,
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFourPaymentDateLabel)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                                _c("div", { staticClass: "custom-select" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.paymentDate.$model,
                                          expression: "$v.paymentDate.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.$v.paymentDate,
                                            "$model",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "",
                                            disabled: "",
                                            hidden: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.labels
                                                .stepFourPaymentDatePlaceholder
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v("1st"),
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "8" } }, [
                                        _vm._v("8th"),
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "15" } }, [
                                        _vm._v("15th"),
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "22" } }, [
                                        _vm._v("22nd"),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$v.paymentDate.required
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.labels.stepFourPaymentDateValidationMsg
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "form-group--error":
                                _vm.$v.paymentAccountName.$error,
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.labels.stepFourAccountHolderNameLabel
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.paymentAccountName.$model,
                                  expression: "$v.paymentAccountName.$model",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.$v.paymentAccountName.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.paymentAccountName,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$v.paymentAccountName.required
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.labels
                                    .stepFourAccountHolderNameValidationMsg
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "form-group--error":
                                _vm.$v.paymentAccountNumber.$error,
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFourAccountNumberLabel)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.paymentAccountNumber.$model,
                                  expression: "$v.paymentAccountNumber.$model",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                maxlength: "8",
                                type: "text",
                                placeholder:
                                  _vm.labels.stepFourAccountNumberPlaceholder,
                              },
                              domProps: {
                                value: _vm.$v.paymentAccountNumber.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.paymentAccountNumber,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$v.paymentAccountNumber.required ||
                        !_vm.$v.paymentAccountNumber.minLength ||
                        !_vm.$v.paymentAccountNumber.maxLength ||
                        !_vm.$v.paymentAccountNumber.isPositive ||
                        !_vm.$v.paymentAccountNumber.numeric
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.labels
                                      .stepFourAccountNumberValidationMsg
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "form-group--error":
                                _vm.$v.sortcode1.$error ||
                                _vm.$v.sortcode2.$error ||
                                _vm.$v.sortcode3.$error,
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFourAccountSortLabel)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-2 form-control__container--sort-code",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sortcode1,
                                        expression: "sortcode1",
                                      },
                                    ],
                                    ref: "sortcode1",
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      maxlength: "2",
                                      placeholder:
                                        _vm.labels
                                          .stepFourAccountSortFirstPlaceholder,
                                    },
                                    domProps: { value: _vm.sortcode1 },
                                    on: {
                                      keyup: function ($event) {
                                        return _vm.focusSortCode(2)
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.sortcode1 = $event.target.value
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-2 form-control__container--sort-code",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sortcode2,
                                        expression: "sortcode2",
                                      },
                                    ],
                                    ref: "sortcode2",
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      maxlength: "2",
                                      placeholder:
                                        _vm.labels
                                          .stepFourAccountSortSecondPlaceholder,
                                    },
                                    domProps: { value: _vm.sortcode2 },
                                    on: {
                                      keyup: function ($event) {
                                        return _vm.focusSortCode(3)
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.sortcode2 = $event.target.value
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-2 form-control__container--sort-code",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sortcode3,
                                        expression: "sortcode3",
                                      },
                                    ],
                                    ref: "sortcode3",
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      maxlength: "2",
                                      placeholder:
                                        _vm.labels
                                          .stepFourAccountSortThirdPlaceholder,
                                    },
                                    domProps: { value: _vm.sortcode3 },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.sortcode3 = $event.target.value
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$v.sortcode1.required ||
                        !_vm.$v.sortcode1.numeric ||
                        !_vm.$v.sortcode1.maxLength ||
                        !_vm.$v.sortcode1.minLength ||
                        !_vm.$v.sortcode1.isPositive ||
                        !_vm.$v.sortcode2.required ||
                        !_vm.$v.sortcode2.numeric ||
                        !_vm.$v.sortcode2.maxLength ||
                        !_vm.$v.sortcode2.minLength ||
                        !_vm.$v.sortcode2.isPositive ||
                        !_vm.$v.sortcode3.required ||
                        !_vm.$v.sortcode3.numeric ||
                        !_vm.$v.sortcode3.maxLength ||
                        !_vm.$v.sortcode3.isPositive ||
                        !_vm.$v.sortcode3.minLength
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.labels.stepFourAccountSortValidationMsg
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: { claas: "quotetool__step-payment-results" },
                          },
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.labels.stepFourPaymentNote) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            Direct Debit payment:"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            Payments: " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      _vm.totalCharge / _vm.paymentTermNumber,
                                      2
                                    )
                                  ) +
                                  " x" +
                                  _vm._s(_vm.paymentTermNumber)
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            Recipient: Pennon Water Services Ltd t/a Source for Business"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            Bank: 10 Gresham Street, London, EC2V 7AE"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            Acc. Number: 00220418"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            Sort: 30-00-00\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row quotetool__step-direct-debit" },
                          [
                            _c("div", { staticClass: "col-xs-8" }, [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(
                                    _vm.labels
                                      .stepFourDirectDebitGuaranteeHeading
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-4" }, [
                              _c("img", {
                                staticClass:
                                  "pull-right img-responsive direct-debit-logo",
                                attrs: {
                                  src: "/dist/img/direct-debit-logo.png",
                                  title: "Direct Debit - Logo",
                                  alt: "Direct Debit - Logo",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-12" }, [
                              _c("ul", [
                                _c("li", [
                                  _vm._v(
                                    "The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "If there are any changes to the amount, date or frequency of your Direct Debit Source for Business will notify you (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you request Source for Business to collect a payment, confirmation of the amount and date will be given to you at the time of the request"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "If an error is made in the payment of your Direct Debit, by Source for Business or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "If you receive a refund you are not entitled to, you must pay it back when Source for Business asks you to"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify Source for Business."
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.waterPaymentVAT.$error,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.labels.stepFourVATLabel)),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.waterPaymentVAT.$model,
                                expression: "$v.waterPaymentVAT.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "waterPaymentVAT",
                              id: "waterPaymentVATYes",
                            },
                            domProps: {
                              value: true,
                              checked: _vm._q(
                                _vm.$v.waterPaymentVAT.$model,
                                true
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.waterPaymentVAT,
                                  "$model",
                                  true
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepFourVATYesLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.waterPaymentVAT.$model,
                                expression: "$v.waterPaymentVAT.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "waterPaymentVAT",
                              id: "waterPaymentVATNo",
                            },
                            domProps: {
                              value: false,
                              checked: _vm._q(
                                _vm.$v.waterPaymentVAT.$model,
                                false
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.waterPaymentVAT,
                                  "$model",
                                  false
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepFourVATNoLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.waterPaymentVAT.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.labels.stepFourVATValidationMsg)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.termsAcceptance.$error,
                      },
                    },
                    [
                      _c("div", { staticClass: "checkbox" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.termsAcceptance.$model,
                                expression: "$v.termsAcceptance.$model",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: true,
                              checked: Array.isArray(
                                _vm.$v.termsAcceptance.$model
                              )
                                ? _vm._i(_vm.$v.termsAcceptance.$model, true) >
                                  -1
                                : _vm.$v.termsAcceptance.$model,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.$v.termsAcceptance.$model,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = true,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.$v.termsAcceptance,
                                        "$model",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.$v.termsAcceptance,
                                        "$model",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.$v.termsAcceptance,
                                    "$model",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.labels.stepFourTermsConditionsLabel
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.termsAcceptance.required ||
                  !_vm.$v.termsAcceptance.isTrue
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.labels.stepFourTermsConditionsValidationMsg
                            ) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  true
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepFourDocusignValidationMsg)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.labels.stepFourContractNote) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.receiveInformation.$error,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.labels.stepFourAdditionalInfoLabel)),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.receiveInformation.$model,
                                expression: "$v.receiveInformation.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "receiveInformation",
                              id: "receiveInformationYes",
                            },
                            domProps: {
                              value: true,
                              checked: _vm._q(
                                _vm.$v.receiveInformation.$model,
                                true
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.receiveInformation,
                                  "$model",
                                  true
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.labels.stepFourAdditionalInfoYesLabel
                              ) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.receiveInformation.$model,
                                expression: "$v.receiveInformation.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "receiveInformation",
                              id: "receiveInformationNo",
                            },
                            domProps: {
                              value: false,
                              checked: _vm._q(
                                _vm.$v.receiveInformation.$model,
                                false
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.receiveInformation,
                                  "$model",
                                  false
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepFourAdditionalInfoNoLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.receiveInformation.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.labels.stepFourAdditionalInfoValidationMsg
                            ) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.receiveInformation == false
                    ? _c("p", [
                        _vm._v(
                          "              \n                    " +
                            _vm._s(
                              _vm.labels.stepFourDeclinedAdditionalInfoMsg
                            ) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.receiveInformation == true
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "form-group--error":
                                _vm.$v.receiveInformationType.$error,
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.labels
                                    .stepFourCommunicationPreferenceLabel
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.$v.receiveInformationType.$model,
                                      expression:
                                        "$v.receiveInformationType.$model",
                                    },
                                  ],
                                  attrs: { type: "checkbox", value: "email" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.$v.receiveInformationType.$model
                                    )
                                      ? _vm._i(
                                          _vm.$v.receiveInformationType.$model,
                                          "email"
                                        ) > -1
                                      : _vm.$v.receiveInformationType.$model,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.$v.receiveInformationType.$model,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "email",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.$v.receiveInformationType,
                                          "$model",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.labels.stepFourCommunicationEmail
                                    ) +
                                    "\n                                "
                                ),
                                _c("span", { staticClass: "checkmark" }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.$v.receiveInformationType.$model,
                                      expression:
                                        "$v.receiveInformationType.$model",
                                    },
                                  ],
                                  attrs: { type: "checkbox", value: "post" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.$v.receiveInformationType.$model
                                    )
                                      ? _vm._i(
                                          _vm.$v.receiveInformationType.$model,
                                          "post"
                                        ) > -1
                                      : _vm.$v.receiveInformationType.$model,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.$v.receiveInformationType.$model,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "post",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.$v.receiveInformationType,
                                          "$model",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.labels.stepFourCommunicationPost
                                    ) +
                                    "\n                                "
                                ),
                                _c("span", { staticClass: "checkmark" }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.$v.receiveInformationType.$model,
                                      expression:
                                        "$v.receiveInformationType.$model",
                                    },
                                  ],
                                  attrs: { type: "checkbox", value: "phone" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.$v.receiveInformationType.$model
                                    )
                                      ? _vm._i(
                                          _vm.$v.receiveInformationType.$model,
                                          "phone"
                                        ) > -1
                                      : _vm.$v.receiveInformationType.$model,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.$v.receiveInformationType.$model,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "phone",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$v.receiveInformationType,
                                              "$model",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.$v.receiveInformationType,
                                          "$model",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.labels.stepFourCommunicationPhone
                                    ) +
                                    "\n                                "
                                ),
                                _c("span", { staticClass: "checkmark" }),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$v.receiveInformationType.required
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v(
                                "\n                        Please specify your preferred communication methods\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn--chevron",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.labels.stepFourConfirmPaymentButton))]
                  ),
                ],
                1
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }